// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CommitteeAttachment } from './committee-attachment';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CommitteeAttachmentReview extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  closed?: Date;
  code!: string;
  committeeAttachmentId?: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  dismissed?: Date;
  packageNumber!: number;
  personId?: number;
  sent?: Date;
  viewed?: Date;
  committeeAttachment!: CommitteeAttachment;
  person!: Person;
}

